import locale from "localization/en";

export const shiftRecordColumns = [
  { key: "stationCode", text: locale.stationCode, width: "100px" },
  { key: "stationName", text: locale.stationName, width: "200px" },
  { key: "startShift", text: locale.startShift, width: "200px" },
  { key: "endShift", text: locale.endShift, width: "200px" },
  { key: "shiftNumber", text: locale.shiftNumber },
  { key: "cashier", text: locale.cashier },
  { key: "totalSales", text: locale.totalSales },
  { key: "syncProgress", text: locale.syncProgress },
  { key: "actions", text: locale.action },
];
